import React from 'react';
import { Building2 } from 'lucide-react';

interface ConnectTargetOrgSelectProps {
  orgs: { id: string; name: string }[];
  value: string | null;
  onChange: (orgId: string) => void;
  /** Compact inline form for use inside a modal footer/body. */
  variant?: 'bar' | 'inline';
  disabled?: boolean;
}

/**
 * Which business a new data source will be filed under. Renders nothing when
 * there is only one business — the choice would be theatre.
 */
const ConnectTargetOrgSelect: React.FC<ConnectTargetOrgSelectProps> = ({
  orgs,
  value,
  onChange,
  variant = 'bar',
  disabled = false,
}) => {
  if (orgs.length <= 1) return null;

  const select = (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      aria-label="Business to add this source to"
      className="px-3 py-1.5 text-sm text-foreground bg-card border border-input rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-ring focus:border-primary disabled:opacity-50"
    >
      {/* No ambient default with several businesses (R9) — the pick is explicit. */}
      {value === null && <option value="">Choose a business…</option>}
      {orgs.map((org) => (
        <option key={org.id} value={org.id}>
          {org.name}
        </option>
      ))}
    </select>
  );

  if (variant === 'inline') {
    return (
      <div className="flex items-center gap-2 mb-4 p-3 rounded-lg bg-muted border border-border">
        <Building2 className="w-4 h-4 text-muted-foreground flex-shrink-0" />
        <span className="text-sm text-muted-foreground flex-shrink-0">Adding to</span>
        {select}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Building2 className="w-4 h-4 text-muted-foreground flex-shrink-0" />
      <span className="text-sm text-muted-foreground flex-shrink-0">Adding to</span>
      {select}
    </div>
  );
};

export default ConnectTargetOrgSelect;
